"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { motion, PanInfo, useDragControls } from "framer-motion";
import { Fragment, ReactNode, useRef } from "react";
export default function ArtistPreviewAppWrapper(t0) {
  const $ = _c(21);
  const {
    isOpen,
    onClose,
    children
  } = t0;
  const constraintsRef = useRef(null);
  const dragControls = useDragControls();
  let t1;
  if ($[0] !== onClose) {
    t1 = (_, info) => {
      if (info.offset.y > 80 || info.velocity.y > 300) {
        onClose();
      }
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleDragEnd = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TransitionChild as={Fragment} enter="tw-ease-in-out tw-duration-300" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-ease-in-out tw-duration-300" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px] tw-transition-opacity" /></TransitionChild>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <XMarkIcon className="tw-w-6 tw-h-6 tw-flex-shrink-0 tw-text-white" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClose) {
    t4 = <TransitionChild as={Fragment} enter="tw-ease-in-out tw-duration-300" enterFrom="tw-opacity-0" enterTo="tw-opacity-100" leave="tw-ease-in-out tw-duration-300" leaveFrom="tw-opacity-100" leaveTo="tw-opacity-0"><div className="tw-absolute tw-right-0 -tw-top-16 -tw-ml-8 tw-flex tw-pr-2 tw-pt-4 sm:-tw-ml-10 sm:tw-pr-4"><button type="button" aria-label="Close panel" className="tw-p-2.5 tw-relative tw-bg-transparent tw-rounded-md focus:tw-outline-none tw-border-none focus:tw-ring-2 focus:tw-ring-white" onClick={onClose}>{t3}</button></div></TransitionChild>;
    $[4] = onClose;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children) {
    t5 = <div className="tw-flex-1 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800">{children}</div>;
    $[6] = children;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <DialogPanel className="tw-w-full tw-bg-iron-950 tw-shadow-xl tw-flex tw-flex-col tw-rounded-t-2xl tw-pb-[env(safe-area-inset-bottom,0px)] tw-max-h-[85vh] tw-relative">{t4}{t5}</DialogPanel>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== dragControls || $[12] !== handleDragEnd || $[13] !== t6) {
    t7 = <div className="tw-fixed tw-inset-0 tw-flex tw-items-end" onClick={_temp} onTouchStart={_temp2} ref={constraintsRef}><TransitionChild as={Fragment} enter="tw-transform tw-ease-out tw-duration-300" enterFrom="tw-translate-y-full" enterTo="tw-translate-y-0" leave="tw-transform tw-ease-in tw-duration-300" leaveFrom="tw-translate-y-0" leaveTo="tw-translate-y-full"><motion.div drag="y" dragConstraints={constraintsRef} dragElastic={0.1} onDragEnd={handleDragEnd} dragControls={dragControls} dragListener={false} className="tw-pointer-events-auto tw-w-full">{t6}</motion.div></TransitionChild></div>;
    $[11] = dragControls;
    $[12] = handleDragEnd;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onClose || $[16] !== t7) {
    t8 = <Dialog as="div" className="tw-fixed tw-inset-0 tw-z-[1010] tw-overflow-hidden tailwind-scope" onClose={onClose}>{t2}{t7}</Dialog>;
    $[15] = onClose;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isOpen || $[19] !== t8) {
    t9 = <Transition appear={true} show={isOpen} as={Fragment}>{t8}</Transition>;
    $[18] = isOpen;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}